import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import saveAs from "file-saver";
import * as XLSX from "xlsx";
import "./index.css";

/* API requests */
import { getVerifiedReferences } from "../../../../api-requests/reference";

/* Components */
import { VerificationDocument } from "../../../ReferenceVerification/ReferenceVerificationPDF";

const DownloadIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <path d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

class References extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [] };
    }

    componentDidMount() {
        getVerifiedReferences().then(result => this.setState({ data: result }));
    }

    generate = (document, reference) => {
        let blobPdf = pdf(document);
        blobPdf.updateContainer(document);
        return blobPdf.toBlob().then(result => saveAs(result, `${reference.referenceName} Reference.pdf`));
    }

    exportXlsx = () => {
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        return fetch("/api/candidates/all-references")
            .then(res => res.json())
            .then(json => {
                const ws = XLSX.utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                return saveAs(data, `References.xlsx`);
            })
            .catch(err => console.log(err));
    }

    render() {

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">References</h1>
                        <p className="admin-page-subtitle">Verified references, grouped by date.</p>
                    </div>
                    <button type="button" className="admin-page-action admin-page-action--ghost" onClick={() => this.exportXlsx()}>
                        <DownloadIcon />
                        <span>Export</span>
                    </button>
                </header>

                {this.state.data.length === 0 &&
                    <p className="admin-empty-state">No verified references yet.</p>
                }

                {this.state.data.map((date, index) => (
                    <section key={index} className="references-group">
                        <p className="references-group-title">{date.title}</p>
                        <div className="admin-card-list">
                            {date.items.map((reference, idx) => {
                                const verifiedPDF = <VerificationDocument candidate={reference.candidate} reference={reference} />;
                                return (
                                    <div key={idx} className="references-item admin-card">
                                        <div className="references-item-row">
                                            <span className="references-item-label">Candidate</span>
                                            <a href={"/crew/profile/" + reference.candidate._id} target="_blank" rel="noopener noreferrer" className="references-item-link">
                                                {reference.candidate.firstName} {reference.candidate.lastName}
                                            </a>
                                        </div>
                                        <div className="references-item-row">
                                            <span className="references-item-label">Document</span>
                                            <span className="references-item-link" onClick={() => this.generate(verifiedPDF, reference)}>
                                                {reference.referenceName} Reference.pdf
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </section>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({ ...bindActionCreators({}, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(References);
